import { Button } from '@/components/ui/button';
import { ChevronLeft } from 'lucide-react';
import { useNavigationHistory } from '@/contexts/NavigationHistoryContext';

/** Shown atop a top-level page only when another surface sent the user there. */
export default function MissionReturnLink() {
  const { missionOrigin, goBack } = useNavigationHistory();
  if (!missionOrigin) return null;
  return (
    <div className="container-wide px-4 sm:px-6 lg:px-8 pt-3">
      <Button variant="quiet" size="sm"
        type="button"
        onClick={() => goBack(missionOrigin.pathname)}
        className="h-auto min-h-10 px-0 whitespace-normal text-left justify-start inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
      >
        <ChevronLeft className="w-4 h-4" />
        Back to {missionOrigin.label}
      </Button>
    </div>
  );
}
